import { z } from 'zod';
import {
    MaterialPayloadDiscriminatedSchema,
    MaterialPayloadPartialDiscriminatedSchema,
} from './mappings/material-payload.ts';
import {
    MATERIAL_PRODUCT_CATEGORY_SCHEMA,
    MATERIAL_PRODUCT_TYPES_SCHEMA,
    MATERIAL_SUPPORTED_UNITS_SCHEMA,
} from './mappings/material-types.ts';
import { floatingPointPrecisionSchema } from '../position/floating-point-precision-schema.ts';

const AbstractMaterialPositionQuoteBaseSchema = z.object({
    positionId: z.string().uuid(),
    positionProductId: z.string().uuid(),
    quota: floatingPointPrecisionSchema,
    unit: MATERIAL_SUPPORTED_UNITS_SCHEMA,
    partnerOrganizationId: z.number().positive(),
    projectOwnerOrganizationId: z.number().positive(),
    platformOrganizationId: z.number().positive(),
    purchasePrice: z.number(),
    purchaseTaxClassId: z.string(),
    salesPrice: z.number(),
    salesTaxClassId: z.string(),
    currencyCode: z.string().max(3),
    productCategory: MATERIAL_PRODUCT_CATEGORY_SCHEMA,
    productType: MATERIAL_PRODUCT_TYPES_SCHEMA,
});

export const BaseMaterialPositionQuoteSchema = AbstractMaterialPositionQuoteBaseSchema.and(
    MaterialPayloadDiscriminatedSchema
);

export const BaseMaterialPositionQuoteSchemaPartial = AbstractMaterialPositionQuoteBaseSchema.partial().and(
    MaterialPayloadPartialDiscriminatedSchema
);
